import React from 'react';
import ReactDOM from 'react-dom';

export default class ReactPortalsRoot extends React.Component{
  constructor(props){
    super(props)
    this.el = document.createElement('div');
    this.props.wrapperClassNames ? this.el.className = this.props.wrapperClassNames : null;
  };

  componentDidMount() {
    this.props.portalTarget 
    ? 
    this.props.portalTarget.appendChild(this.el)
    // this.props.portalTarget.appendChild(this.props.children)  ? May need to do an append of children, may not
    : 
    document.body.appendChild(this.el);
  }

  componentWillUnmount() {
    this.props.portalTarget 
    ? 
    this.props.portalTarget.removeChild(this.el)
    // this.props.portalTarget.removeChild(this.props.children) ? if appending children is needed will need to remove them
    : 
    document.body.removeChild(this.el);
  }

  render(){
    return ReactDOM.createPortal(
      this.props.children,
      this.props.portalTarget ? this.props.portalTarget : this.el
    );
  };


}